import { render, staticRenderFns } from "./StatisticsMiniCard.vue?vue&type=template&id=37176012&scoped=true&"
import script from "./StatisticsMiniCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37176012",
  null
  
)

export default component.exports